import { apiList, apiGet, apiCreate, apiUpdate, apiDelete } from './apiClient';

export const getProperties = async (_params?: any) => apiList('properties');
export const getPropertyById = async (id: number | string) => apiGet('properties', id);
export const createProperty = async (data: any) => apiCreate('properties', data);
export const updateProperty = async (id: number | string, data: any) => apiUpdate('properties', id, data);
export const deleteProperty = async (id: number | string) => apiDelete('properties', id);
